import 'babel-polyfill';

import './web_base';
import VueQuillEditor, { Quill } from '@components/VueQuillEditor';
import ImageResize from '../quill/plugin/ImageResize';

import '../ui';

import Vue from 'vue';

import Share from '@business/Share/Share';

import store from '@store';

import '../extend';
import '@directives';
import '@components';
import '@filters';
// import i18n from '@i18n';
Vue.use(VueQuillEditor /* { default global options } */);

Quill.register('modules/ImageResize', ImageResize);
Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
  // i18n,
  el: '#app',
  store,
  render: h => h(Share)
});
